// components/FieldSidebar.jsx
import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Drawer,
  Grid,
  Switch,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FieldTypeSpecificOptions from "./FieldTypeSpecificOptions";

const FieldSidebar = ({
  classes,
  sidebarOpen,
  setSidebarOpen,
  selectedField,
  setSelectedField,
  handleSaveFieldChanges,
}) => {
  const updateFields = useSelector((item) => item.DocsLibrary.updateFields);
  if (!selectedField) return null;

  const fieldType = selectedField?.type || "";

  return (
    <Drawer
      anchor="right"
      open={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      classes={{ paper: classes.sidebarDrawer }}
    >
      <Box className={classes.sidebarHeader}>
        <Typography variant="h6">Field Properties</Typography>
        <IconButton onClick={() => setSidebarOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className={classes.sidebarContent}>
        <TextField
          label="Field Name"
          fullWidth
          margin="normal"
          value={selectedField?.name || ""}
          disabled
          onChange={(e) => {
            // setSelectedField({
            //   ...selectedField,
            //   field: {
            //     ...selectedField.field,
            //     name: e.target.value,
            //   },
            // })
          }}
        />
        <TextField
          label="Caption"
          fullWidth
          margin="normal"
          value={selectedField?.caption || ""}
          onChange={(e) => {
            setSelectedField({
              ...selectedField,
              caption: e.target.value,
            });
          }}
        />
        <TextField
          label="Instructions"
          fullWidth
          margin="normal"
          multiline
          rows={2}
          value={selectedField?.instructions || ""}
          onChange={(e) => {
            setSelectedField({
              ...selectedField,
              instructions: e.target.value,
            });
          }}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Field Type</InputLabel>
          <Select
            value={fieldType}
            label="Field Type"
            onChange={(e) => {
              setSelectedField({
                ...selectedField,
                type: e.target.value,
              });
            }}
          >
            <MenuItem value="string">Text</MenuItem>
            <MenuItem value="number">Number</MenuItem>
            <MenuItem value="date">Date</MenuItem>
            <MenuItem value="checkbox-list">Checkbox</MenuItem>
            <MenuItem value="radio">Radio</MenuItem>
            <MenuItem value="clause">Text Area</MenuItem>
            <MenuItem value="people">People</MenuItem>
            <MenuItem value="location">Location</MenuItem>
            <MenuItem value="telephone">Telephone</MenuItem>
            <MenuItem value="signature">Signature</MenuItem>
            <MenuItem value="logo">Logo</MenuItem>
            <MenuItem value="multiline">Multiline</MenuItem>
          </Select>
        </FormControl>

        {/* Model can update switch */}
        <FormControlLabel
          control={
            <Switch
              checked={selectedField?.model_can_update || false}
              onChange={(e) => {
                setSelectedField({
                  ...selectedField,
                  model_can_update: e.target.checked,
                });
              }}
            />
          }
          label="Model can update"
          sx={{ marginTop: 2, marginBottom: 1 }}
        />

        <PositionSizeSection
          classes={classes}
          selectedField={selectedField}
          setSelectedField={setSelectedField}
        />

        <FieldTypeSpecificOptions
          classes={classes}
          fieldType={fieldType}
          selectedField={selectedField}
          setSelectedField={setSelectedField}
        />

        <Box className={classes.actionButtons}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveFieldChanges}
          >
            Save Changes{" "}
            {updateFields?.isLoading ? (
              <CircularProgress color="inherit" size={20} />
            ) : null}
          </Button>
          <Button variant="outlined" onClick={() => setSidebarOpen(false)}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

const PositionSizeSection = ({ classes, selectedField, setSelectedField }) => {
  return (
    <>
      <Box className={classes.positionSection}>
        <Typography variant="subtitle1" gutterBottom>
          Position
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="X Position (%)"
              type="number"
              fullWidth
              value={selectedField?.x_pos_per || "0"}
              disabled
              onChange={(e) => {
                // setSelectedField({
                //   ...selectedField,
                //   field: {
                //     ...selectedField.field,
                //     x_pos_per: e.target.value,
                //   },
                // });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Y Position (%)"
              type="number"
              fullWidth
              value={selectedField?.y_pos_per || "0"}
              disabled
              onChange={(e) => {
                // setSelectedField({
                //   ...selectedField,
                //   field: {
                //     ...selectedField.field,
                //     y_pos_per: e.target.value,
                //   },
                // });
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.sizeSection}>
        <Typography variant="subtitle1" gutterBottom>
          Size
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Width"
              type="number"
              fullWidth
              value={selectedField?.width || "100"}
              disabled
              onChange={(e) => {
                // setSelectedField({
                //   ...selectedField,
                //   field: {
                //     ...selectedField.field,
                //     width: e.target.value,
                //   },
                // })
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Height"
              type="number"
              fullWidth
              value={selectedField?.height || "30"}
              disabled
              onChange={(e) => {
                // setSelectedField({
                //   ...selectedField,
                //   field: {
                //     ...selectedField.field,
                //     height: e.target.value,
                //   },
                // })
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default FieldSidebar;
